import React, { Component } from 'react';
import classnames from 'classnames';
import cls from './loader-dots.module.scss';
import PropTypes from 'prop-types';

export default class Loader extends Component
{
    constructor(props)
    {
        super(props);

        const { isLoading } = props;

        this.state =
        {
            isLoading: isLoading
        }
    }
    
    static getDerivedStateFromProps(props, state)
    {
        if (props.isLoading != null && props.isLoading !== state.isLoading)
        {
            return { isLoading: props.isLoading }
        }
        
        return null;
    }

    render()
    {
        const classOptions =
        {
            [cls.white]: this.props.white,
            [cls.primary]: this.props.primary,
            [cls.gray]: this.props.gray,
            hidden: !this.state.isLoading,
            [cls.fullWidth]: this.props.fullWidth,
            [cls.large]: this.props.large,
            [cls.centerHorizontal]: this.props.centerHorizontal
        }

        return(
            this.props.spinner ?
            <div className={ classnames([cls.spinnerloaderContainer, classOptions, this.props.className]) }>
                <div className={ cls.spinnerloader }>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            :
            <div className={ classnames([cls.dotloader, classOptions])}>
                <div className={ cls.dotloader1 } />
                <div className={ cls.dotloader2 } />
                <div className={ cls.dotloader3 } />
            </div>
        );
    }
}

Loader.propTypes =
{
    isLoading: PropTypes.bool,
    white: PropTypes.bool,
    primary: PropTypes.bool,
    gray: PropTypes.bool,
    fullWidth: PropTypes.bool,
    large: PropTypes.bool,
    spinner: PropTypes.bool,
    className: PropTypes.string,
    centerHorizontal: PropTypes.bool
}

Loader.defaultProps =
{
    isLoading: false,
    white: false,
    primary: true,
    gray: false,
    fullWidth: false,
    large: false,
    spinner: false
}